export default "__VITE_PUBLIC_ASSET__b71542ef__"